<atn-ds-page>
  <atn-ds-table [config]="tableConfig">
    <ng-container customTools>
      <!-- ------------------ Apply Rules & Prepare Proposal ------------------- -->
      <i
        class="atn-icon atn-run atn-blue"
        (click)="applyRulesClickHandler()"
      ></i>
    </ng-container>
  </atn-ds-table>
</atn-ds-page>

<!-- ----------------------------------------------------------------------- -->
<!--                         Slide-out(s) & dialogs                         -->
<!-- ----------------------------------------------------------------------- -->

<!-- ----------------------- Edit Rule Slide-out ------------------------ -->
<atn-rate-rule-slideout />

<!-- ----------------------- Delete Rule Overlay ------------------------ -->
@if (ruleEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()) {
  <atn-ds-confirmation-overlay
    title="Delete Rule"
    description="Are you sure that you want to delete rule?"
    (confirm)="deleteRuleConfirmationOverlayBtnConfirmClickHandler()"
    (cancel)="deleteRuleConfirmationOverlayBtnCancelClickHandler()"
  />
}
